<mat-sidenav-container [hasBackdrop]="true" class="itempage-sidenav-container">
  <mat-sidenav #addBudgetPopUp mode="over" position="end" class="itempage-sidenav-budget">
    <h2 class="budget-form-header">Add Budget</h2>
    <app-add-budget #popUp [isReadOnly]="isReadOnly" (addBudgetHandler)="closeNav($event)" [BudgetForm]="BudgetForm"
    (budgetTypeValue)="handleBudgetTypeChange($event)"
      [ActionType]="popUpActionType" [isQuantity]="isQuantity" [control]="popUpBudgetAllocForm"
      [budgetInitialState]="budgetInitialState" [formType]="'multi'" class="vendor-sidenav"></app-add-budget>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="tab-body">

      <div class="form-inputs">
        <p class="paragraph-medium-regular">Please select the number of budgets to use</p>
        <mat-button-toggle-group name="noOfBudget" [(ngModel)]="isSingleBudget" [ngModelOptions]="{standalone: true}"
          (change)="onNumberOfBudgetChange($event)" [disabled]="isReadOnly">
          <mat-button-toggle [value]="true">Single</mat-button-toggle>
          <mat-button-toggle [value]="false">Multiple</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <!-- Single choice -->
      <ng-container class="form-inputs" *ngIf="isSingleBudget">
        <app-add-budget (showProjectCompletionMessage)="showProjectCompletionMessage($event)"
        (budgetTypeValue)="handleBudgetTypeChange($event)"
          [control]="addBudgetAllocForm" [budgetInitialState]="budgetInitialState"
          [isReadOnly]="isReadOnly"></app-add-budget>
      </ng-container>
      <!-- Multi choice-->
      <ng-container class="form-inputs" *ngIf="!isSingleBudget">
        <div class="form-inputs">
          <p class="paragraph-medium-regular">Please select the preferred unit of distribution</p>
          <mat-button-toggle-group name="noOfBudget" [(ngModel)]="isQuantity" [ngModelOptions]="{standalone: true}"
            (change)="onUnitOfDistibutionChange($event)" [disabled]="isReadOnly">
            <mat-button-toggle [value]="true">Quantity</mat-button-toggle>
            <mat-button-toggle [value]="false">Percentage</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div>
          <app-button class="budgetBtn" name="Add Budget" type="flat-button" 
          [disabled]="isReadOnly" tabindex="0" (keypress)="!isReadOnly && openSideNav(toAddBudget)" (click)="!isReadOnly && openSideNav(toAddBudget)">
          </app-button>
        </div>
        <mat-tab-group>
          <mat-tab label="Operating ({{budgetCount.operating}})"><app-budget-listing-table [budgetType]="'Operating'"
              [sideNav]="budgetPopUp" [budgetList]="BudgetForm" [budgetCount]="budgetCount" 
              (tableAction)="openSideNav($event)" [isReadOnly]="isReadOnly"  [isQuantity]="isQuantity"></app-budget-listing-table></mat-tab>
          <mat-tab label="Capital ({{budgetCount.capital}})"><app-budget-listing-table [budgetType]="'Capital'"
              [sideNav]="budgetPopUp" [budgetList]="BudgetForm" [budgetCount]="budgetCount" 
              (tableAction)="openSideNav($event)" [isReadOnly]="isReadOnly" [isQuantity]="isQuantity"></app-budget-listing-table></mat-tab>
          <mat-tab label="Capital AUC ({{budgetCount.capitalAuc}})"><app-budget-listing-table
              [budgetType]="'Capital AUC'" [sideNav]="budgetPopUp" [budgetList]="BudgetForm" [budgetCount]="budgetCount" 
              (tableAction)="openSideNav($event)" [isReadOnly]="isReadOnly" [isQuantity]="isQuantity"></app-budget-listing-table></mat-tab>
          <mat-tab label="Project ({{budgetCount.project}})"><app-budget-listing-table [budgetType]="'Project'"
              [sideNav]="budgetPopUp" [budgetList]="BudgetForm" [budgetCount]="budgetCount"
              (tableAction)="openSideNav($event)" [isReadOnly]="isReadOnly" [isQuantity]="isQuantity"></app-budget-listing-table></mat-tab>
        </mat-tab-group>
      </ng-container>
      <ng-container *ngIf="isProjectNearCompletionSelected">
        <div class="single-budget-view">
          <div class="form-inputs form-dropdown project-completion header">
              <div><mat-icon class="icon">warning</mat-icon></div>
              <ng-container>
                <span> {{projectCompletionMessage}}</span>
              </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>